export default "__VITE_PUBLIC_ASSET__2f8d26fa__"